import React, { useEffect, useState } from "react";
import styles from "./ekyc.module.scss";

const AIEvaluation = ({ token }) => {
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
  }, []);
  return (
    <div className={styles.ekycWrapper}>
        <h5>Ekyc AI Evaluation</h5>
    </div>
  );
};

export default AIEvaluation;
